module.exports = __webpack_public_path__ + "img/delete_alert.013674e1.svg";